<div class="invoice-row-list astral-stack-m">
  @if (!dataContext.allowEditInvoiceRows) {
    <astral-toggle [control]="filterFormGroup.controls['showInformationRow']"></astral-toggle>
  }
  <app-drag-drop-list-view
    [columnDefinition]="columnDefinition"
    [contextMenuDefinition]="dataContext.allowEditInvoiceRows ? menuDefinition : []"
    [itemsSource]="itemsSource"
    [displayRowNumber]="false"
    [enableDragDrop]="canEdit"
    [enableDragDropItem]="canEditRow"
    [previewText]="getDragPreviewText"
    (itemDropped)="drop($event)"
    (rowClick)="onInvoiceRowClicked($event)"
  ></app-drag-drop-list-view>
  <astral-layout-group [columns]="4" [tabletColumns]="2" [mobileColumns]="1">
    <div class="invoice-row-list__summary">
      <span>{{ 'INVOICE.PREVIEW.ROUNDING' | translate }}: </span>
      <app-money-box [dataContext]="rounding"></app-money-box>
    </div>
    <div class="invoice-row-list__summary">
      <span>{{ 'INVOICE.TOTAL_AMOUNT' | translate }}: </span>
      <app-money-box [dataContext]="invoiceTotal"></app-money-box>
    </div>
  </astral-layout-group>
  <div class="astral-form-actions invoice-row-list__actions">
    @if (canEdit) {
      <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="INVOICE_ROW.NEW_ROW" (click)="addInvoiceRow()"></astral-button>
    }
    @if (canEdit) {
      <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="INVOICE_ROW.NEW_INFOROW" (click)="addInfoRow()"></astral-button>
    }
  </div>
  @if (canEdit && favoriteArticles) {
    <div class="astral-form-actions invoice-row-list__actions">
      @for (article of favoriteArticles; track article) {
        <astral-button
          variant="secondary"
          size="small"
          type="button"
          icon="plus"
          [label]="article.toString()"
          (click)="addFavorite(article.id)"
        ></astral-button>
      }
    </div>
  }
</div>

<ng-template #rowEditSidebar>
  <ng-container>
    <app-invoice-row-form
      #rowForm
      [dataContext]="formContext"
      (rowCreated)="invoiceRowCreated($event)"
      (rowChanged)="invoiceRowChanged($event)"
      (rowDeleted)="invoiceRowDeleted($event)"
      (canceled)="invoiceRowEditCanceled()"
    ></app-invoice-row-form>
  </ng-container>
</ng-template>
